/**
 * Created : vincent
 * Date : 2017/4/24  下午3:36
 * Email : wangxiao@wafersystems.com
 */
import React from 'react';
import { connect } from 'dva';
import { message, Modal, Tree } from 'antd';
import { SEMICOLON } from '../../utils/constants';
import RegionalMaintenanceTreeOperation from './RegionalMaintenanceTreeOperation';

const TreeNode = Tree.TreeNode;

class RegionalMaintenanceTree extends React.Component {
  constructor(props) {
    super(props);
    this.makeFloor = this.makeFloor.bind(this);
    this.makeRoom = this.makeRoom.bind(this);
    this.makeNode = this.makeNode.bind(this);
    this.delHandle = this.delHandle.bind(this);
    this.addHandle = this.addHandle.bind(this);
    this.state = {
      expandedKeys: []
    };
  }

  componentWillMount() {
    const { allAreaData } = this.props;
    //默认展开
    let defaultExpandKey = [];
    allAreaData &&
      allAreaData.child &&
      allAreaData.child.map(c => {
        defaultExpandKey.push(c.id + '');
      });
    this.setState({ expandedKeys: defaultExpandKey });
  }

  makeFloor(data) {
    return data.child.map(v => {
      v.parentName = data.name;
      return this.makeNode(
        v,
        v.rooms && v.rooms.length > 0 ? this.makeRoom : false,
        false
      );
    });
  }

  makeRoom(data) {
    return data.rooms.map(v => {
      return this.makeNode(v, false, false);
    });
  }

  addHandle(node) {
    const { intl, dispatch, isEdit, editEditFlag } = this.props;
    if(isEdit) {
      message.info(intl.formatMessage({id: 'account_zone_add_value1'}));
      return;
    }
    editEditFlag(true);
    dispatch({ type: 'account/addAreaNode', node: node });
    this.state.expandedKeys.push(`${node.id}`);
    this.setState({
      expandedKeys: this.state.expandedKeys
    });
  }

  delHandle(node) {
    const { dispatch, intl, cancelEditHandle } = this.props;
    Modal.confirm({
      // title: '您确认删除这条记录吗?',
      content: intl.formatMessage({ id: 'region_confirm_delete_record' }),
      onOk() {
        cancelEditHandle(node);
        if (node.hasOwnProperty('deviceIds')) {
          dispatch({ type: 'account/deleteRome', roomId: node.id });
        } else {
          dispatch({ type: 'account/deleteZone', id: node.id });
        }
      },
      onCancel() {}
    });
  }

  makeNode(v, child, showAdd) {
    if (child) {
      return (
        <TreeNode
          title={
            <RegionalMaintenanceTreeOperation
              dispatch={this.props.dispatch}
              intl={this.props.intl}
              title={v.name}
              node={v}
              titleState={this.props.titleState}
              addHandle={showAdd ? this.addHandle : false}
              cancelEditHandle={this.props.cancelEditHandle}
              editHandle={this.props.editHandle}
              save={this.props.save}
              delHandle={this.delHandle}
            />
          }
          key={v.id}
        >
          {child(v)}
        </TreeNode>
      );
    } else {
      return (
        <TreeNode
          title={
            <RegionalMaintenanceTreeOperation
              dispatch={this.props.dispatch}
              intl={this.props.intl}
              title={v.name}
              node={v}
              titleState={this.props.titleState}
              addHandle={showAdd ? this.addHandle : false}
              cancelEditHandle={this.props.cancelEditHandle}
              editHandle={this.props.editHandle}
              save={this.props.save}
              delHandle={this.delHandle}
            />
          }
          key={v.id}
        />
      );
    }

    return <TreeNode title="111" />;
  }

  render() {
    const { allAreaData, findRoomsFun, parentZoneId } = this.props;
    const { child: zones = [] } = allAreaData;
    return (
      <Tree
        expandedKeys={this.state.expandedKeys}
        className="maintenance-tree"
        onExpand={expandedKeys => {
          //处理一个奇怪的bug，每次拖拽二级zone时，onExpand方法返回的expandedKeys会出错，因此这里需要剔除一下
          expandedKeys.forEach((expandKey, i) => {
            if (zones.findIndex(zone => String(zone.id) === expandKey) === -1) {
              expandedKeys.splice(i, 1);
            }
          });
          this.setState({
            expandedKeys: expandedKeys
          });
        }}
        onSelect={(selectedKeys, info) => {
          if (selectedKeys.length > 0) {
            let zoneId = selectedKeys[0];
            findRoomsFun(zoneId);
          } else {
            findRoomsFun(parentZoneId);
          }
        }}
        draggable
        onDrop={this.onDrop}
      >
        {zones.map(v => {
          v.parentName = allAreaData.name;
          return this.makeNode(
            v,
            v.child && v.child.length > 0 ? this.makeFloor : false,
            true
          );
        })}
      </Tree>
    );
  }

  onDrop = ({
    event,
    node,
    dragNode,
    dragNodesKeys,
    dropPosition,
    dropToGap
  }) => {
    const { allAreaData, dispatch } = this.props;
    const { child: zones = [] } = allAreaData;
    const dropKey = node.props.eventKey;
    const dragKey = dragNode.props.eventKey;
    const dropPos = node.props.pos.split('-');
    dropPosition = dropPosition - Number(dropPos[dropPos.length - 1]);
    const loop = (data, key, callback) => {
      data.forEach((item, index, arr) => {
        if (String(item.id) === key) {
          return callback(item, index, arr);
        }
        if (item.child && item.child.length > 0) {
          return loop(item.child, key, callback);
        }
      });
    };
    const data = [...zones];
    let dragObj, dropObj;
    loop(data, dragKey, (item, index, arr) => {
      dragObj = item;
    });
    loop(data, dropKey, (item, index, arr) => {
      dropObj = item;
    });
    if (dragObj && dropObj && dragObj.parId === dropObj.parId && dropToGap) {
      //只允许同级调整顺序
      loop(data, dragKey, (item, index, arr) => {
        //从原有位置删除dragObj
        arr.splice(index, 1);
      });
      let ar;
      let i;
      loop(data, dropKey, (item, index, arr) => {
        ar = arr;
        i = index;
      });
      if (dropPosition === -1) {
        ar.splice(i, 0, dragObj);
      } else {
        ar.splice(i + 1, 0, dragObj);
      }

      dispatch({
        type: 'account/update',
        payload: { allAreaData: { ...allAreaData, child: data } }
      });
      const breadthFirstLoop = (arr = [], callBack) => {
        arr.forEach(item => {
          callBack(item);
          if (item.child && item.child.length > 0) {
            breadthFirstLoop(item.child, callBack);
          }
        });
      };
      let zoneIdsInOrd = [];
      breadthFirstLoop(data, zone => {
        zoneIdsInOrd.push(zone.id);
      });
      dispatch({
        type: 'account/changeZoneOrd',
        zoneIdsInOrd: zoneIdsInOrd.join(SEMICOLON)
      });
    } else {
      event.preventDefault();
    }
  };
}

export default connect()(RegionalMaintenanceTree);



// WEBPACK FOOTER //
// ./src/components/account/RegionalMaintenanceTree.js